import React, {Component} from 'react'
import {connect} from 'react-redux'
import {buildUrlFromParams} from '../../common/functions/url'
import WithAjax from '../../common/helpers/WithAjax'
import { setJumbotronTitle } from '../../../actions/common'
import ClientRequestSearch from './ClientRequestSearch'
import ClientRequestList from './ClientRequestList'

class ClientRequestManager extends Component {
  constructor() {
    super()
    this.search = this.search.bind(this)

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Client access requests');
    this.search();
  }

  search() {
	  var clientsFieldValue = this.props.clientRequestSearch.find((el) => {
      return el.name === 'Client';
    });

    let url = buildUrlFromParams(
      'clientaccounts/pending',
      {
		  ownerId: clientsFieldValue.value
      });

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });
      this.setState({
        items: data
      })
    })
  }

  render() {
    return (
      <div>
		    <ClientRequestList items={this.state.items} onReload={this.search} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
	clientRequestSearch: state.clientRequestSearch.fields
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ClientRequestManager))
